import ReviewRating from './ReviewRating';

export const ReviewRatingThree = {
  component: ReviewRating,
  props: { rating: 3 },
};

export const ReviewRatingFive = {
  component: ReviewRating,
  props: { rating: 5 },
};



// WEBPACK FOOTER //
// ./src/components/ReviewRating/ReviewRating.example.js